export const ColorsDef = {
  // Listagem
  defaultBadgeVariant: 'info',
  // Cadastros
  usuarioVariant: 'info',
  rolesVariant: 'success',
  permissoesVariant: 'dark',
  // Sistemas
  aplicacaosVariant: 'danger',
  // Atividades
  historyVariant: 'light',
};

export const APLICACOES = {
  IAM_SIGLA: 'iam',
  PLANNER_SIGLA: 'planner',
};

export const Permissao = {
  ORGANIZACAO: 'iam_organizacao_editar',
  // Planner
  PROJETO_EDITAR: 'planner_projeto_editar',
  PROJETO_EXCLUIR: 'planner_projeto_excluir',
  TAREFA_CRIAR: 'planner_tarefa_criar',
  TAREFA_EDITAR: 'planner_tarefa_editar',
  TAREFA_EXCLUIR: 'planner_tarefa_excluir',
};

//Constantes e identificadores de armazenomentos locais
const lsKey = 'iam_v001';
export const localStorageDef = {
  key: lsKey,
  // User
  usuarioContextKey: `${lsKey}_usuario`, //Identificador de armazenomento do usuário
  i18nContextKey: `${lsKey}_i18n`, //Identificador de armazenomento do usuário
};

//Qauntidade de itens por página
export const defaultPageSize = 50;
